import script from "./RefreshComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./RefreshComponent.vue?vue&type=script&setup=true&lang=ts"

import "./RefreshComponent.vue?vue&type=style&index=0&id=6dbaa0e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dbaa0e9"]])

export default __exports__
import QPullToRefresh from 'quasar/src/components/pull-to-refresh/QPullToRefresh.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPullToRefresh});
